module.exports = __webpack_public_path__ + "static/media/errorProfile.79e7ba5e.svg";